import { configureStore } from '@reduxjs/toolkit'
import { baseApi } from './api/baseApi'

import userReducer from "../slices/userSlice";
import dictReducer from "../slices/dictSlice";

export const store = configureStore({
    reducer: {
        user: userReducer,
        dict: dictReducer,
        [baseApi.reducerPath]: baseApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(baseApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
